<template>
  <div class="commonIndex">
    <main>
      <notice v-if="$store.getters.checkNotice"></notice>
      <firstRow :class="{ 'fillet' : !$store.getters.checkReminder }" :fullTicketInfo="fullTicketInfo" @clickPay="nextStep" :fullPrice="Number(fullPrice)"></firstRow>
      <ticketType
        ref="DOMticketType"
        @changeSeasonTicket="changeSeasonTicket"
        :saleDateInfos="saleDateInfos">
      </ticketType>
      <numberController v-if="ticketInfoList.length" @changePeopleNumber="changePeopleNumber" :ticketInfoList="ticketInfoList"></numberController>
      <emptyContent text="当前没有可售门票" v-else></emptyContent>
    </main>
    <calculationAction
      nextStepName="下一步"
      @nextStep="nextStep"
      :fullPrice="Number(fullPrice)"
      :controllerNumber="controllerNumber"
    ></calculationAction>
  </div>
</template>

<script>
import firstRow from "@/components/buyTickets/common/firstRow";
import { getProductMulti } from "@/service/buyTickets/common.js";
import ticketType from "@/components/buyTickets/shoppingCart/ticketType";
import numberController from "@/components/buyTickets/shoppingCart/numberController";
import calculationAction from "@/components/buyTickets/shoppingCart/calculationAction";
export default {
  name: "touristshoppingCart",
  data(){
    return {
      // 可展示为购物车的索引
      fullTicketInfo: {},
      // 一组票的数据
      ticketInfoList: [],
      saleDateInfos: [],
      controllerNumber: [],
      fullPrice: 0,
      currentSeason: this.$getCurrentSeason(),
      checkPreSaleDate: this.$checkPreSaleDate(),
      ticketPool: {
        currentSeasonTicketInfoList: [],
        reserveSeasonTicketInfoList: [],
      },
    }
  },
  created(){
    this.resetAction();
    this.getTicketList();
  },
  methods: {
    resetAction(){
      const orderinformation = window.sessionStorage.getItem('orderinformation') || false;
      const controllerNumber = window.sessionStorage.getItem('controllerNumber') || false;
      const oftenContacts = window.sessionStorage.getItem('oftenContacts') || false;
      orderinformation && window.sessionStorage.removeItem('orderinformation');
      controllerNumber && window.sessionStorage.removeItem('controllerNumber');
      oftenContacts && window.sessionStorage.removeItem('oftenContacts');
    },
    nextStep(){
      // 没选时段
      if (!this.$refs.DOMticketType.currentTime)return this.$toast("请选择时段");
      // 判断要展开，并且有长度
      if(!this.controllerNumber.length)return this.$toast("请选择购买数量");
      // 并且必须有数量
      if(!this.controllerNumber.some(v => v.count > 0))return this.$toast("请选择购买数量");
      const total = this.controllerNumber.reduce((cur, pre) => {
        return cur += pre.count
      }, 0);
      const quantity = Number(this.$store.state.quantity.describe)
      if(total > quantity)return this.$toast(`每笔订单限制总人数不超过${quantity}人`);
      const { currentDays, currentIndex2 } = this.$refs.DOMticketType;
      const { datePeriodInfos } = currentDays;
      const selectDate = {
        saleDate: currentDays.saleDate,
        datePeriodInfo: datePeriodInfos[currentIndex2],
      };
      // 无年龄限制自主前端填充
      this.controllerNumber.forEach(v => {
        const { metaTicketInfo } = v;
        if(!metaTicketInfo.saleAgeInfos.length){
          metaTicketInfo.saleAgeInfos.push({
            travellerMaxAge: "1000",
            travellerMinAge: "0"
          })
        }
      });
      window.sessionStorage.setItem('orderinformation', JSON.stringify({
        controllerNumber: this.controllerNumber,
        selectDate,
        fullTicketInfo: this.fullTicketInfo,
      }));
      this.$beyondHiding(false);
      this.$router.push('/touristfitplaceorder');
    },
    changePeopleNumber({ controllerNumber }){
      this.controllerNumber = controllerNumber;
    },
    ticketInSaleDateInfos(saleDateInfos){
      saleDateInfos.forEach(item => {
        item.ticketState = item.datePeriodInfos.some((v) => parseInt(v.resourceCount) > 0);
        if(!item.dateType)item.dateType = 'current';
      });
      this.saleDateInfos = saleDateInfos;
    },
    async bridgingOffPeakSeasonDate(saleDateInfos){
      console.log(saleDateInfos)
      const needFillingDays = parseInt(process.env.VUE_APP_PRE_SALE_QUANTITY) - saleDateInfos.length;
      const { ticketcode } = this.$route.query;
      const reserveTicketWindow = this.$store.state.reserveTicketWindow;
      const { productSns } = Object.values(reserveTicketWindow).flat().find(item => item.code === ticketcode);
      const result = await getProductMulti({ productSns });
      const reserveSeasonTicketInfoList = result.data;
      if(reserveSeasonTicketInfoList.length != 0) {
        this.ticketPool.reserveSeasonTicketInfoList = reserveSeasonTicketInfoList;
        const reserveSaleDateInfos = reserveSeasonTicketInfoList[0].saleDateInfos.splice(0, needFillingDays);
        saleDateInfos.forEach(item => item.dateType = 'current')
        reserveSaleDateInfos.forEach(item => item.dateType = 'reserve')
        const newSaleDateInfos = saleDateInfos.concat(reserveSaleDateInfos);
        this.ticketInSaleDateInfos(newSaleDateInfos)
      }else{
        this.ticketInSaleDateInfos(saleDateInfos)
      }
    },
    setFullTicketInfo(ticketWindow){
      const fullData = Object.values(ticketWindow).reduce((pre, cur) => {
        cur.forEach(v => {
          pre.push(v)
        });
        return pre;
      }, []);
      const fullTicketInfo = fullData.find(({ code }) => code === this.$route.query.ticketcode)
      this.fullTicketInfo = fullTicketInfo;
    },
    changeSeasonTicket(currentDays){
      if(!this.checkPreSaleDate)return;
      const { dateType } = currentDays;
      if(dateType === 'current'){
        this.ticketInfoList = this.ticketPool.currentSeasonTicketInfoList;
        this.setFullTicketInfo(this.$store.state.ticketWindow);
      }else{
        this.ticketInfoList = this.ticketPool.reserveSeasonTicketInfoList;
        this.setFullTicketInfo(this.$store.state.reserveTicketWindow);
      }
    },
    async getTicketList(){
      const ticketList = this.$store.state.ticketWindow;
      this.setFullTicketInfo(ticketList);
      const productSns = this.fullTicketInfo.productSns;
      const result = await getProductMulti({ productSns });
      this.ticketInfoList = result.data;
      if(!this.ticketInfoList.length)return;
      this.ticketPool.currentSeasonTicketInfoList = JSON.parse(JSON.stringify(this.ticketInfoList));
      if(!this.checkPreSaleDate){
        this.ticketInSaleDateInfos(result.data[0].saleDateInfos);
      }else{
        this.bridgingOffPeakSeasonDate(result.data[0].saleDateInfos)
      };
    },
  },
  watch: {
    controllerNumber: {
      handler(newValue){
        const fullPrice = newValue.reduce((total, currentValue, currentIndex, arr) => {
          total += Number(currentValue.salePrice) * currentValue.count;
          return total;
        }, 0);
        this.fullPrice = String(fullPrice.toFixed(2)).padStart(2, 0);
      },
      deep: true,
    }
  },
  components: {
    firstRow,
    ticketType,
    numberController,
    calculationAction,
  },
};
</script>

<style scoped lang="less">
.empty{
  /deep/ .content-box{
    border-bottom: none;
  }
}

main{
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /deep/ .booth {
    padding-bottom: 2.026667rem;
    background: #ffffff;
  }
};

.fillet{
  border-radius: 0.16rem 0.16rem 0 0;
}
</style>
